import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown, Modal, Table } from 'app/components';
import { deleteOrganizer, getOrganizersList } from './api';
import { ACTION_ITEMS, COLUMN_CONFIG } from './constants';

const OrganizersList = () => {
  const { organizersList, filters, totalPages } = useSelector((state) => state.adminPrimaryOrganizersList);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [deletableOrgtId, setDeletableOrgId] = useState(null); 

  useEffect(() => {
    getOrganizersList({ ...filters });
  }, [filters]);

  const onChangeTableData = (key, value) => {
    const filterKey = key === 'search' ? 'searchText' : key;

    if (filters?.[filterKey] !== value) {
      dispatch({
        type: 'ADMIN_PRIMARY_ORGANIZERS_LIST:FILTERS:SET',
        data: {
          ...filters,
          [filterKey]: value,
          ...(filterKey !== 'page_no' && ({
            page_no: 1,
          })),
        },
      });
    }
  };

  const onClickActionItem = (actionItem, row) => {
    if (actionItem.action === 'edit') {
      navigate(`../admin/primary/organizers/${row?.business_config_id}`)
    } else if (actionItem.action === 'delete') {
      setDeletableOrgId(row?.business_config_id);
    }
  };

  const onDeleteOrganizer = () => {
    deleteOrganizer(deletableOrgtId, () => {
      if (filters?.page_no !== 1) onChangeTableData('page_no', 1);
      else getOrganizersList(filters);

      setDeletableOrgId(null);
    });
  };

  return (
    <div className="flex flex-col gap-4 p-5 admin-events-list">
      <Table
        totalPages={totalPages}
        showSearch={true}
        columns={COLUMN_CONFIG}
        rows={organizersList}
        selectedPage={filters?.page_no}
        searchText={filters?.searchText}
        onChange={onChangeTableData}
        actionItems={ACTION_ITEMS}
        onClickActionItem={onClickActionItem}
      />
      <Modal
        className="delete-confirmation-modal"
        primaryText="Delete"
        size="regular"
        isOpen={!!deletableOrgtId}
        onClickPrimaryCta={onDeleteOrganizer}
        onClickSecondaryCta={() => setDeletableOrgId(null)}
        title="Are you sure you want to delete this organizer?"
      />
    </div>
  );
};

export default OrganizersList;
